export default {
  // Navegación principal
  goToHome: 'Ir al Inicio',
  home: 'Inicio',
  aboutUs: 'Quiénes Somos',
  solutions: 'Soluciones',
  training: 'Capacitación',

  // Usuario
  profile: 'Perfil',
  logout: 'Cerrar Sesión',
  enter: 'ENTRAR',

  // Menú principal
  organizationalDefinitions: 'Definiciones Organizacionales',
  curricularDefinitions: 'Definiciones Curriculares',
  curricularProducts: 'Productos Curriculares',
  createPrograms: 'Crear Programas',
  programRegistry: 'Registro de Programas',

  // Modos y configuración
  editMode: 'Modo edición',
  editForm: 'Editar Formulario',
  printOrientation: 'Orientación al Imprimir',
  horizontal: 'Horizontal',
  vertical: 'Vertical',
  printZoom: 'Zoom al Imprimir',

  // Submenu items
  totalList: 'Listado Total de',
  registry: 'Registro de',

  // Alertas
  exitEditModeWarning: 'Debe salir del modo edición antes de poder imprimir.',
}
